<template>
	<div v-if="userHasUnpublishedVideos" class="video-notification-banner">
		<div class="video-notification-text">
			You have borrower video reviews to approve.
		</div>

		<button
			class="b360-btn--secondary manage-account-btn"
			aria-label="manage SocialV account"
			@click="handleSocialVReDirect"
		>
			<span v-if="showSpinner === false">
				Manage Account
				<font-awesome-icon class="icon" :icon="['far', 'external-link-alt']" />
			</span>
			<font-awesome-icon
				v-if="showSpinner"
				class="waiting-animation"
				:icon="['far', 'circle-notch']"
			/>
		</button>
		<font-awesome-icon
			:icon="['fal', 'times']"
			@click="handleClose"
			role="button"
			aria-label="close"
			class="close"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';
export default {
	name: 'UnpublishedVideoBanner',
	components: {
		FormLabelTooltip,
	},
	data() {
		return {
			showSpinner: {
				typeof: Boolean,
				default: false,
			},
		};
	},
	mounted() {
		this.showSpinner = false;
	},
	computed: {
		...mapGetters([]),
		...mapState({
			userHasUnpublishedVideos: (state) =>
				state.profile.userHasUnpublishedVideos,
		}),
	},
	methods: {
		...mapActions(['getADFSLink', 'setUserHasVideoReviews']),
		handleClose() {
			this.setUserHasVideoReviews(false);
			this.showSpinner = false;
		},
		async handleSocialVReDirect() {
			try {
				this.showSpinner = true;
				await this.getADFSLink();
				this.handleClose();
			} catch (error) {
				this.showSpinner = false;
			}
		},
	},
};
</script>

<style lang="scss">
.video-notification-banner {
	display: flex;
	padding: 0.5rem;
	margin-bottom: 1rem;
	align-items: center;
	background-color: $highlight-color;
	border-radius: $b360-border-radius-base;
	color: $b360-color--blue;
	border: 1px solid $b360-color--blue;
	max-width: 800px;
	@include sm {
		display: grid;
		grid-template-columns: 1fr, 2fr, 1fr, 1fr;
		grid-template-rows: auto;
		gap: none;
		grid-template-areas:
			'videoText . close'
			'button . .';
	}
}
.video-notification-text {
	padding-right: 0.5rem;
	@include sm {
		grid-area: videoText;
		justify-self: start;
		margin-bottom: 0.5rem;
	}
}
.manage-account-btn {
	border: none;
	margin-left: auto;
	margin-right: 0.5rem;
	font-weight: 500;
	height: fit-content;
	width: 35%;
	@include sm {
		grid-area: button;
		justify-self: start;
		width: fit-content;
		height: auto;
		margin-left: 0;
	}
}
.icon {
	margin-left: 0.5rem;
	@include sm {
	}
}
.close {
	padding-right: 0.5rem;
	@include sm {
		grid-area: close;
		justify-self: end;
	}
}
.waiting-animation {
	animation: spin 1.5s ease-in-out infinite;
}
</style>
